import { ContentPages } from "@/components/Search/SearchBar/components/ResultsPanel/components/Results/ContentPages/contentPages";
import {
    useResults,
    useResultsContext
} from "@/components/Search/SearchBar/components/ResultsPanel/components/Results/context/results.context";
import { Products } from "@/components/Search/SearchBar/components/ResultsPanel/components/Results/Products/products";
import { QuerySuggestions } from "@/components/Search/SearchBar/components/ResultsPanel/components/Results/QuerySuggestions/querySuggestions";
import { RecentSearches } from "@/components/Search/SearchBar/components/ResultsPanel/components/Results/RecentSearches/recentSearches";
import { Base } from "@/components/Search/SearchBar/components/ResultsPanel/components/Results/results.base";

export const Results = Object.assign(Base, {
    useContext: useResultsContext,
    useResults: useResults,
    ContentPages: ContentPages,
    Products: Products,
    QuerySuggestions: QuerySuggestions,
    RecentSearches: RecentSearches
});
